
import React from "react";
import { Badge } from "@/components/ui/badge";

interface TicketPriorityBadgeProps {
  priority: 'low' | 'medium' | 'high' | 'critical';
  className?: string;
}

const TicketPriorityBadge: React.FC<TicketPriorityBadgeProps> = ({ 
  priority, 
  className 
}) => {
  const getPriorityConfig = () => {
    switch (priority) {
      case 'low':
        return { label: 'Low', variant: 'outline', bg: 'bg-gray-200 text-gray-700' };
      case 'medium':
        return { label: 'Medium', variant: 'secondary', bg: 'bg-blue-200 text-blue-700' };
      case 'high':
        return { label: 'High', variant: 'default', bg: 'bg-amber-500 text-white' };
      case 'critical':
        return { label: 'Critical', variant: 'destructive', bg: 'bg-red-500 text-white' };
      default:
        return { label: 'Unknown', variant: 'outline', bg: 'bg-gray-500' };
    }
  };

  const config = getPriorityConfig();

  return (
    <Badge 
      variant="outline" 
      className={`${config.bg} ${className}`}
    >
      {config.label}
    </Badge>
  );
};

export default TicketPriorityBadge;
